import { excelRowDayPlanQuantity } from "./week39-quantities";
import { formatCaseQuantity } from "./week39-view";
import type { PackagingPlanRow } from "./week39-types";

type Props = { label: string; actualValues: Array<number | null | undefined>; rows: PackagingPlanRow[]; date: string };

export function capacityDayPercentage({ actualValues, rows, date }: Omit<Props, "label">): number | null {
  if (!actualValues.length || actualValues.some((value) => value === null || value === undefined || !Number.isFinite(value))) return null;
  const plans = rows.map((row) => excelRowDayPlanQuantity(row, date).value);
  if (plans.some((value) => value === null || !Number.isFinite(value))) return null;
  const plan = plans.reduce<number>((sum, value) => sum + (value ?? 0), 0);
  const actual = actualValues.reduce<number>((sum, value) => sum + (value ?? 0), 0);
  const percentage = Math.round(actual / plan * 100);
  return plan > 0 && Number.isFinite(percentage) ? percentage : null;
}

export function Week39CapacityProductionValue(props: Props) {
  const percentage = capacityDayPercentage(props);
  if (percentage === null) return props.label;
  const plan = props.rows.reduce((sum, row) => sum + (excelRowDayPlanQuantity(row, props.date).value ?? 0), 0);
  return <span className="pack39-capacity-production-value"><span>{props.label}</span>
    <small aria-label={`Günlük plan karşılama yüzde ${percentage}`}
      title={`Planlı işlerin üretimi: ${formatCaseQuantity(props.actualValues.reduce<number>((sum, value) => sum + (value ?? 0), 0))} KOLİ · Günlük plan: ${formatCaseQuantity(plan)} KOLİ. Oran = üretim / günlük plan. Başka günün planına ait üretimler de bu günün üretimine dahildir.`}>
      <span>Plan karşılama:</span> %{percentage.toLocaleString("tr-TR")}
    </small></span>;
}
